
  import {Component, Ref, Vue, Watch} from "vue-property-decorator";
  import api from '@/api/index'
  import {ElForm} from "element-ui/types/form";
  import {AuditFlowDto, PayOrderDto, PayOrderType, UserDiffCardRefundInput} from "@/api/appService";

  @Component
  export default class DiffCardRefundDialog extends Vue {
    @Ref() readonly dataForm!: ElForm;

    show=false;
    userId:number = 0;

    private balance:number = 0;
    private payOrderList:PayOrderDto[] = [];
    private auditFlowList:AuditFlowDto[] = [];

    private defaultForm:UserDiffCardRefundInput = {
      amount:0,
      auditFlowId:'',
      desc:'',
      orderId:0
    }

    private refundForm = {...this.defaultForm};

    created(){
      this.refundForm.orderId = undefined;
      api.auditFlow.getAll({maxResultCount:65535}).then(res=>{
        this.auditFlowList = res.items!;
      })
    }

    @Watch('userId')
    onUserIdChange(newValue:number){
      api.userCard.getUserDiffCardBalance({userId:newValue}).then(res=>{
        this.balance = res;
      })

    }

    @Watch('show')
    onShowChange(value:boolean){
      if(value){
        api.payOrder.getAll({
          type:PayOrderType.DiffCard,
          isSuccessPay:true,
          creatorUserId:this.userId,
          maxResultCount:65535})
          .then(res=>{
            this.payOrderList = res.items!.filter(s=>!s.refundPrice || s.refundPrice!<s.totalPrice!);
          })
      } else {
        this.refundForm = {...this.defaultForm};
        this.refundForm.orderId = undefined;
        this.$nextTick(()=>{
          this.dataForm.clearValidate();
        });

      }
    }

    handleSubmit(){
      this.dataForm.validate((valid:boolean)=>{
        if(!valid){
          return
        }
        api.userDiffCard.refund({body:this.refundForm}).then(res=>{
          this.show = false;
        })


      });
    }


    refundInputRules = {
      amount:[
        {required:true,message:'退款金额是必须的',trigger:['change','blur']},
        {
          type:'number',
          message:'退款金额必须大于或等于0.01',
          trigger:['change','blur'],
          validator:(rule:any,value:number,callback:Function)=>{
            if(value>=0.01){
              callback();
            } else {
              callback(new Error('退款金额必须大于或等于0.01'))
            }
          }},
      ],
      auditFlowId:[
        {required:true,message:'请选择审核流程',trigger:['change','blur']}
      ],
      desc:[
        {required:true,type:'string',message:'退款原因是必须的',trigger:['change','blur']}
      ],
      orderId:[
        {required:true,message:'请选择一个要退款的订单',trigger:['change','blur']}
      ]
    }

  }
